<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-6">
        <h4 class="f-bold pt-2 pl-3 cl-primary text-left" v-if="!id">
          Add Address
        </h4>
        <h4 class="f-bold pt-2 pl-3 cl-primary text-left" v-if="id">
          Edit Address
        </h4>
      </div>
      <div class="col-12 col-md-6">
        <nav aria-label="breadcrumb">
          <ol
            class="breadcrumb float-right"
            style="background-color: transparent"
          >
            <li class="breadcrumb-item">
              <router-link to="/admin/dashboard">Dashboard</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/admin/address">Data Address</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Form Address
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="d-flex justify-content-around" v-if="loading">
      <loader-component></loader-component>
    </div>
    <form @submit.prevent="submit" v-if="!loading">
      <div class="row text-left">
        <div class="col-md-12">
          <label for="" class="text-left">Title</label>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              id="title"
              aria-describedby="title"
              placeholder="Title"
              v-model="form.title"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="description" class="text-secondary text-left"
              >Address</label
            >
            <textarea
              name="description"
              id="description"
              placeholder="Description"
              cols="30"
              rows="7"
              v-model="form.warehouse_address"
              class="form-control"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-md-12">
          <div class="d-flex justify-content-end">
            <button class="btn btn-primary px-5" type="submit" v-if="!id">
              Save
            </button>
            <button class="btn btn-primary px-5" type="submit" v-if="id">
              Update
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import Vue from "vue";
import LoaderComponent from "../../components/Loader.vue";
export default {
  props: ["id"],
  name: "AddressForm",
  components: { LoaderComponent },
  data() {
    return {
      loading: false,
      form: {
        title: "",
        warehouse_address: "",
        id: "",
      },
    };
  },

  computed: {
    userLogin: function () {
      return this.$store.getters.getProfileCustomers;
    },
  },

  mounted() {
    console.log(this.id);
    if (this.id) {
      this.getBlog();
    }
  },
  methods: {
    submitBlog() {
      Vue.swal({
        title: "Are you sure?",
        text: "Your data will be entered",
        icon: "question",
        showCancelButton: true,
        cancelButtonColor: "#eb4d4b",
        confirmButtonText: "Yes, Submit Address!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          this.$store
            .dispatch("postAddress", this.form)
            .then((res) => {
              this.loading = false;
              console.log(res);
              this.resetForm();
              Vue.swal(
                res.data.status,
                "Your data is already added",
                "success"
              ).then(() => {
                this.toList();
              });
            })
            .catch((err) => {
              let errorMsg = "";
              this.loading = false;
              Object.keys(err.response.data).forEach(function (key) {
                let errorItem = key.charAt(0).toUpperCase() + key.slice(1);
                let errorCause = "";
                let errorLists = err.response.data[key];
                for (var prop in errorLists) {
                  errorCause += "<li>" + errorLists[prop] + "</li>";
                }
                errorMsg +=
                  "<ul style='list-style: none; text-align: left;' class='text-left'><b>" +
                  errorItem +
                  "</b>" +
                  errorCause +
                  "</ul><br>";
              });

              Vue.swal({
                icon: "error",
                title: "Error!",
                html: errorMsg,
              });
              console.log(err.response.data);
            });
        }
      });
    },

    submit() {
      if (this.id) {
        this.updateBlog();
      } else {
        this.submitBlog();
      }
    },

    resetForm() {
      (this.form.title = ""),
        (this.form.body = ""),
        (this.form.status = ""),
        (this.form.images = null);
    },

    handleUploadImage() {
      this.form.images = this.$refs.images.files[0];
      console.log(this.form.image);
    },

    toList() {
      this.$router.push("/admin/address");
    },

    getBlog() {
      this.loading = true;
      const endpoint = "warehouse-address/" + this.id;
      this.$api.get(endpoint, (status, data, message) => {
        console.log(status);
        if (status == 200) {
          this.loading = false;
          this.form = data.warehouse_address;
          console.log(data);
        } else {
          this.loading = false;
          console.log(message);
        }
      });
    },

    updateBlog() {
      Vue.swal({
        title: "Are you sure?",
        text: "Your data will be updated",
        icon: "question",
        showCancelButton: true,
        cancelButtonColor: "#eb4d4b",
        confirmButtonText: "Yes, Update Banner!",
      }).then((result) => {
        if (result.isConfirmed) {
          let formData = new FormData();
          this.loading = true;
          //   formData.append("id", this.form.id);
          formData.append("title", this.form.title);
          formData.append("subtitle", this.form.subtitle);
          formData.append("image", this.form.image);
          this.$store
            .dispatch("updateBlog", formData, this.id)
            .then((res) => {
              this.loading = false;
              console.log(res);
              this.resetForm();
              Vue.swal(
                res.data.status,
                "Your data is already added",
                "success"
              ).then(() => {
                this.toList();
              });
            })
            .catch((err) => {
              let errorMsg = "";
              this.loading = false;
              Object.keys(err.response.data).forEach(function (key) {
                let errorItem = key.charAt(0).toUpperCase() + key.slice(1);
                let errorCause = "";
                let errorLists = err.response.data[key];
                for (var prop in errorLists) {
                  errorCause += "<li>" + errorLists[prop] + "</li>";
                }
                errorMsg +=
                  "<ul style='list-style: none; text-align: left;' class='text-left'><b>" +
                  errorItem +
                  "</b>" +
                  errorCause +
                  "</ul><br>";
              });

              Vue.swal({
                icon: "error",
                title: "Error!",
                html: errorMsg,
              });
              console.log(err.response.data);
            });
        }
      });
    },
  },
};
</script>
